import { render, staticRenderFns } from "./resultadosProcesamiento.vue?vue&type=template&id=ba3531d8"
import script from "./resultadosProcesamiento.vue?vue&type=script&lang=js"
export * from "./resultadosProcesamiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports